var indentation_default = {
  "indentZero": "_7aAh-",
  "indentOne": "Rvagb",
  "indentTwo": "iCZtK",
  "indentThree": "k4Be0",
  "indentFour": "GufK6",
  "indentFive": "_6soJm",
  "indentSix": "HfW2n"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
